import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import src from 'public/images-next/paperplane.svg';

const PaperPlaneIcon = ({ className }) => <Icon src={src} className={className} />;

PaperPlaneIcon.propTypes = {
  className: PropTypes.string,
};

PaperPlaneIcon.defaultProps = {
  className: '',
};

export default PaperPlaneIcon;
